import React from 'react';
import Button from '@/components/ui/Button';
import { Calendar, MapPin, Building2, DollarSign, Clock, Eye, Filter, Search, X, ChevronDown, TrendingUp, Briefcase, CheckCircle, Send } from 'lucide-react';

const PageHeader = ({ 
loadApplications,
isLoading,
navigate
}) => {


return (
<div className="flex items-center justify-between mb-4">
<div>
<h1 className="text-xl lg:text-3xl font-bold text-text-primary mb-2">My Applications</h1>
<p className="text-text-secondary text-sm">
See all the applications submitted on your behalf
</p>
</div>

<div className="hidden md:flex items-center space-x-3">
<Button
variant="outline"
iconName="RefreshCw"
iconPosition="left"
iconSize={16}
onClick={loadApplications}
disabled={isLoading}
>
Refresh
</Button>

<Button
variant="default"
iconName="Settings"
iconPosition="left"
iconSize={16}
onClick={()=>navigate('/settings',{
state:{
section:'preferences'
}
})}
>
Preferences
</Button>
</div>
</div>
);
};

export default PageHeader;